import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IMarkThreadMessageAsOpenRequestAction {
  data: {
    messageIds: number[];
    threadMessageId: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function markThreadMessageAsOpenRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IMarkThreadMessageAsOpenRequestAction>,
) {
  draft.markThreadMessageAsOpen.config.isLoading = true;
}

export default markThreadMessageAsOpenRequest;
